// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as AdjustFareDataMachine from "../../../app/repo/AdjustFareDataMachine.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";

function AdjustFareTypesCTA(Props) {
  var new_fare_details = Props.new_fare_details;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var fetchFareWithType = function (fare_type) {
    Curry._1(dispatch, {
          TAG: /* UpdateNewFareDetails */2,
          new_fare_datails: {
            TAG: /* Loading */0,
            _0: new_fare_details
          }
        });
    return AdjustFareDataMachine.fetchFare(new_fare_details.data.crn, fare_type, (function (fare_details) {
                  Curry._1(dispatch, {
                        TAG: /* UpdatePreviewButtonStatus */6,
                        is_preview_fare_button_enabled: true
                      });
                  Curry._1(dispatch, {
                        TAG: /* UpdateNewFareDetails */2,
                        new_fare_datails: {
                          TAG: /* Live */1,
                          _0: fare_details
                        }
                      });
                  return Curry._1(dispatch, {
                              TAG: /* UpdateFormDurationSelector */0,
                              form_duration_selector: /* Mins */0
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* UpdateNewFareDetails */2,
                              new_fare_datails: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), country);
  };
  return React.createElement("div", {
              className: "c-adjust-fare-update-from"
            }, React.createElement("p", {
                  className: "adjust-fare-update-from-heading"
                }, "Update Fare from"), new_fare_details.data.has_fixed_strategy ? React.createElement("div", {
                    className: "adjust-fare-update-from-buttons-container"
                  }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "Fixed Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* Fixed */0);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      }), React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "New Fixed Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* NewFixed */1);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      }), React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "Current Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* Current */3);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      }), React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "Actual Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* Actual */2);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      })) : React.createElement("div", {
                    className: "adjust-fare-update-from-buttons-container"
                  }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "Update From Estimated Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* Fixed */0);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      }), React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "Update From Actual Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* Current */3);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      }), React.createElement(RoundedPrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Custom */1,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "adjust-fare-update-from-text"
                                            }, "Update From System Fare");
                                })
                            }, undefined, (function (param) {
                                return fetchFareWithType(/* Actual */2);
                              }), undefined, undefined, undefined, undefined, "adjust-fare-update-from", undefined, undefined)
                      })));
}

var make = AdjustFareTypesCTA;

export {
  make ,
  
}
/* react Not a pure module */
